import React from "react";
import "./SkeletonLoader.scss";

const SkeletonLoader = ({ count = 1 }) => {
  return (
    <div className="skeleton-container">
      {Array(count).fill().map((_, index) => (
        <div key={index} className="skeleton-post">
          <div className="skeleton-header">
            <div className="skeleton-avatar"></div>
            <div className="skeleton-user-info">
              <div className="skeleton-username"></div>
              <div className="skeleton-timestamp"></div>
            </div>
            <div className="skeleton-more"></div>
          </div>
          <div className="skeleton-media"></div>
          <div className="skeleton-actions">
            <div className="skeleton-action"></div>
            <div className="skeleton-action"></div>
            <div className="skeleton-action"></div>
          </div>
          <div className="skeleton-content">
            <div className="skeleton-text"></div>
            <div className="skeleton-text short"></div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SkeletonLoader;
